import React from 'react';
import {cashOutline, locationOutline} from "ionicons/icons";
import {actionToDeleteMyJobProfile} from "../apiHelpers/CommonAction";
import {useIonAlert} from "@ionic/react";

export default function JobProfileCard({jobProfileData,openJobCandidateProfileDetail,myProfile = false}){
    if(!jobProfileData?.id) return;
    const [presentAlert] = useIonAlert();

    const callFunctionToDeleteJobProfile = (id)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this item.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteMyJobProfile(id);
                    }},
            ],
        });
    }

    return(
        <div className="job-card my-job-profile">
            <div className="d-flex ion-align-items-center job-card-header">
                <div className="company-icon-name">
                    {jobProfileData?.name}
                </div>
                <div className={`approved_tag_section_tag ${jobProfileData?.is_approved ? 'approved' : 'not_approved'}`}>
                    {jobProfileData?.is_approved ? 'Approved' : 'Pending'}
                </div>
            </div>
            <hr/>
            <div className="job-info"><h3>{jobProfileData?.category}</h3>
                <div className="company-rating">Preferred Work Type - {jobProfileData?.work_type}</div>
                <div className="company-rating">Current Salary - {jobProfileData?.current_salary}</div>
                <div className="job-meta">
                    <span>
                    <ion-icon
                        icon={locationOutline}
                        role="img" className="md hydrated"></ion-icon> {jobProfileData?.location} &nbsp;|&nbsp;
                    </span>
                    <span>
                    <ion-icon
                        icon={cashOutline}
                        role="img" className="md hydrated"></ion-icon>{jobProfileData?.expected_salary}</span>
                </div>
                <div className="tags-row">
                    <span className="job-tag">{jobProfileData?.email}</span>
                </div>
            </div>
            <div className={"in_card_action_buttons_container"}>
                {(myProfile) ?
                    <div onClick={()=>callFunctionToDeleteJobProfile(jobProfileData?.id)} className="in_card_action_button_edit_del delete">
                        Delete
                    </div>
                    :''
                }
                <div onClick={()=>openJobCandidateProfileDetail(jobProfileData)} className="in_card_action_button_edit_del open">
                    Open
                </div>
            </div>
        </div>

    )
}